// src/features/locker-controllers/hooks/useLockerControllerValidation.ts
import { Validator } from 'react-admin';
import { isValidIpAddress, isValidTcpPort, isValidControllerName } from '../types';

export interface UseLockerControllerValidationResult {
  validateName: Validator;
  validateIpAddress: Validator;
  validateTcpPort: Validator;
  validateHotelId: Validator;
  validateZoneId: Validator;
}

export const useLockerControllerValidation = (): UseLockerControllerValidationResult => {
  const validateName: Validator = (value) => {
    if (!value) return 'El nombre es requerido';
    if (typeof value !== 'string') return 'El nombre debe ser texto';
    if (!isValidControllerName(value)) {
      return 'El nombre debe tener entre 2 y 255 caracteres';
    }
    return undefined;
  };

  const validateIpAddress: Validator = (value) => {
    if (!value) return 'La dirección IP es requerida';
    if (typeof value !== 'string') return 'La dirección IP debe ser texto';
    if (!isValidIpAddress(value)) {
      return 'Formato de dirección IP inválido';
    }
    return undefined;
  };

  const validateTcpPort: Validator = (value) => {
    if (value === undefined || value === null) return 'El puerto TCP es requerido';
    const port = Number(value);
    if (isNaN(port)) return 'El puerto debe ser un número';
    if (!isValidTcpPort(port)) {
      return 'El puerto debe estar entre 1 y 65535';
    }
    return undefined;
  };

  const validateHotelId: Validator = (value) => {
    if (!value) return 'El hotel es requerido';
    return undefined;
  };

  const validateZoneId: Validator = (value) => {
    // Zone is optional, so only validate if provided
    return undefined;
  };

  return {
    validateName,
    validateIpAddress,
    validateTcpPort,
    validateHotelId,
    validateZoneId,
  };
};
